import logo from "../../assets/kwik-scout-logo.png";

const KwikScoutLogo = () => (
  <div className="flex justify-center mb-6">
    <img src={logo} alt="Kwik Scout by Instant Solutions" className="h-14" />
  </div>
);

export default KwikScoutLogo;
